import { PropsWithChildren } from "react";

export function RoundedCard({ children }: PropsWithChildren) {
  return <div className="px-4 py-3 border rounded-xl border-blue-grey-200">{children}</div>;
}
export function RoundedCardHeader({ children }: PropsWithChildren) {
  return <h2 className="text-3xs text-text-base-secondary-a font-medium leading-[14px] capitalize!">{children}</h2>;
}
